<!-- Spinner de tela cheia -->
<app-loading-spinner [active]="fullScreenLoading"></app-loading-spinner>

<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card">
                <app-empty-content [isVisible]="!data"
                    title="Nenhum dado encontrado"
                    description="Não foi encontrado nenhum dado de risco nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <ng-container *ngIf="data">
                    <div class="dash-details-card-header"></div>
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-3">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Declarado
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{renderLabel(data?.qualification)}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Se declara PEP?
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data?.politically_exposed
                                        ? 'Sim' : 'Não'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Autoriza a transmissão de ordens por
                                        procurador ou representante?
                                    </span>
                                    <span class="dash-details-card-item-title">
                                        {{data?.authorized_attorney_representative
                                        ? 'Sim' : 'Não'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <app-spacer [bottom]="16"></app-spacer>

            <ng-container *ngIf="pepData && pepData.length">
                <div class="dash-details-card">
                    <div class="dash-details-card-header">
                        <span>
                            Possui relacionamento com PEP
                        </span>
                    </div>
                    <app-spacer [bottom]="25"></app-spacer>

                    <app-table-list [columns]="pepColumns" [data]="pepData">
                    </app-table-list>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </ng-container>

            <div class="dash-details-card">
                <app-empty-content [isVisible]="!data"
                    title="Nenhum dado encontrado"
                    description="Não foi encontrado nenhum dado de risco nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <ng-container *ngIf="data">
                    <div class="dash-details-card-header"></div>
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Opera por conta de terceiros?
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data?.third_party_operation
                                        ? 'Sim' : 'Não'}}

                                        <ng-container
                                            *ngIf="data?.third_party_operation">
                                            -
                                            {{formatDocument(data?.document_number_person_or_company)
                                            ?? '--'}}
                                        </ng-container>

                                        <ng-container
                                            *ngIf="data?.third_party_operation">
                                            | {{data?.name_or_company_name
                                            ?? '--'}}
                                        </ng-container>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Possuí vínculo com a Banvox?
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data?.linked_cm_capital
                                        ? 'Sim' : 'Não'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

<!-- Visualização de comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Versão Principal (Main) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('main')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('main')">
                <ng-container
                    *ngIf="!approvalService.approvalData.mainVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>

                <ng-container *ngIf="approvalService.approvalData.mainVersion">
                    <ng-template #versionTemplate let-data="data"
                        let-versionType="versionType">
                        <div class="dash-details-card">
                            <app-empty-content [isVisible]="!data"
                                title="Nenhum dado encontrado"
                                description="Não foi encontrado nenhum dado de risco nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <ng-container *ngIf="data">
                                <div class="dash-details-card-header"></div>
                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Declarado
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{renderLabel(data?.qualification)}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Se declara PEP?
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data?.politically_exposed
                                                    ? 'Sim' : 'Não'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Autoriza a transmissão de
                                                    ordens por
                                                    procurador ou representante?
                                                </span>
                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data?.authorized_attorney_representative
                                                    ? 'Sim' : 'Não'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>

                        <ng-container
                            *ngIf="getPepDataForView(versionType) && getPepDataForView(versionType).length">
                            <div class="dash-details-card">
                                <div class="dash-details-card-header">
                                    <span>
                                        Possui relacionamento com PEP
                                    </span>
                                </div>
                                <app-spacer [bottom]="25"></app-spacer>

                                <app-table-list
                                    [columns]="getPepColumnsForViewHelper(versionType)"
                                    [data]="getPepDataForView(versionType)">
                                </app-table-list>
                            </div>
                            <app-spacer [bottom]="16"></app-spacer>
                        </ng-container>

                        <div class="dash-details-card">
                            <app-empty-content [isVisible]="!data"
                                title="Nenhum dado encontrado"
                                description="Não foi encontrado nenhum dado de risco nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <ng-container *ngIf="data">
                                <div class="dash-details-card-header"></div>
                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Opera por conta de
                                                    terceiros?
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data?.third_party_operation
                                                    ? 'Sim' : 'Não'}}

                                                    <ng-container
                                                        *ngIf="data?.third_party_operation">
                                                        -
                                                        {{data?.document_number_person_or_company
                                                        ?? '--'}}
                                                    </ng-container>

                                                    <ng-container
                                                        *ngIf="data?.third_party_operation">
                                                        |
                                                        {{data?.name_or_company_name
                                                        ?? '--'}}
                                                    </ng-container>
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Possuí vínculo com a Banvox?
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data?.linked_cm_capital
                                                    ? 'Sim' : 'Não'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>

                    <ng-container
                        *ngTemplateOutlet="versionTemplate; context: { data: getDataForView('main'), versionType: 'main' }"></ng-container>
                </ng-container>
            </ng-container>
        </div>

        <!-- Versão Comparando (Comparing) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('comparing')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('comparing')">
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>

                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion">
                    <ng-template #versionTemplateComparing let-data="data"
                        let-versionType="versionType">
                        <div class="dash-details-card">
                            <app-empty-content [isVisible]="!data"
                                title="Nenhum dado encontrado"
                                description="Não foi encontrado nenhum dado de risco nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <ng-container *ngIf="data">
                                <div class="dash-details-card-header"></div>
                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Declarado
                                                </span>

                                                <div class="dash-details-card-item-title"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        *ngIf="getFieldComparisonIcon('qualification', versionType)"
                                                        [innerHTML]="getFieldComparisonIcon('qualification', versionType)"></span>
                                                    <span
                                                        [ngClass]="getFieldStrikethroughClass('qualification', versionType)">{{renderLabel(getFieldValueForDisplay('qualification',
                                                        data?.qualification,
                                                        versionType))}}</span>
                                                </div>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Se declara PEP?
                                                </span>

                                                <div class="dash-details-card-item-title"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        *ngIf="getFieldComparisonIcon('politically_exposed', versionType)"
                                                        [innerHTML]="getFieldComparisonIcon('politically_exposed', versionType)"></span>
                                                    <span
                                                        [ngClass]="getFieldStrikethroughClass('politically_exposed', versionType)">{{getFieldValueForDisplay('politically_exposed',
                                                        data?.politically_exposed,
                                                        versionType)
                                                        ? 'Sim' : 'Não'}}</span>
                                                </div>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Autoriza a transmissão de
                                                    ordens por
                                                    procurador ou representante?
                                                </span>
                                                <div class="dash-details-card-item-title"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        *ngIf="getFieldComparisonIcon('authorized_attorney_representative', versionType)"
                                                        [innerHTML]="getFieldComparisonIcon('authorized_attorney_representative', versionType)"></span>
                                                    <span
                                                        [ngClass]="getFieldStrikethroughClass('authorized_attorney_representative', versionType)">{{getFieldValueForDisplay('authorized_attorney_representative',
                                                        data?.authorized_attorney_representative,
                                                        versionType)
                                                        ? 'Sim' : 'Não'}}</span>
                                                </div>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>

                        <ng-container
                            *ngIf="getPepDataForComparison(versionType) && getPepDataForComparison(versionType).length">
                            <div class="dash-details-card">
                                <div class="dash-details-card-header">
                                    <span>
                                        Possui relacionamento com PEP
                                    </span>
                                </div>
                                <app-spacer [bottom]="25"></app-spacer>

                                <app-table-list
                                    [columns]="getPepColumnsForViewHelper(versionType)"
                                    [data]="getPepDataForComparison(versionType)">
                                </app-table-list>
                            </div>
                            <app-spacer [bottom]="16"></app-spacer>
                        </ng-container>

                        <div class="dash-details-card">
                            <app-empty-content [isVisible]="!data"
                                title="Nenhum dado encontrado"
                                description="Não foi encontrado nenhum dado de risco nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <ng-container *ngIf="data">
                                <div class="dash-details-card-header"></div>
                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Opera por conta de
                                                    terceiros?
                                                </span>

                                                <div class="dash-details-card-item-title"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        *ngIf="getFieldComparisonIcon('third_party_operation', versionType)"
                                                        [innerHTML]="getFieldComparisonIcon('third_party_operation', versionType)"></span>
                                                    <span
                                                        [ngClass]="getFieldStrikethroughClass('third_party_operation', versionType)">{{getFieldValueForDisplay('third_party_operation',
                                                        data?.third_party_operation,
                                                        versionType)
                                                        ? 'Sim' : 'Não'}}

                                                        <ng-container
                                                            *ngIf="getFieldValueForDisplay('third_party_operation', data?.third_party_operation, versionType)">
                                                            -
                                                            {{formatDocument(getFieldValueForDisplay('document_number_person_or_company',
                                                            data?.document_number_person_or_company,
                                                            versionType))
                                                            ?? '--'}}
                                                        </ng-container>

                                                        <ng-container
                                                            *ngIf="getFieldValueForDisplay('third_party_operation', data?.third_party_operation, versionType)">
                                                            |
                                                            {{getFieldValueForDisplay('name_or_company_name',
                                                            data?.name_or_company_name,
                                                            versionType)
                                                            ?? '--'}}
                                                        </ng-container>
                                                    </span>
                                                </div>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Possuí vínculo com a
                                                    Banvox?
                                                </span>

                                                <div class="dash-details-card-item-title"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        *ngIf="getFieldComparisonIcon('linked_cm_capital', versionType)"
                                                        [innerHTML]="getFieldComparisonIcon('linked_cm_capital', versionType)"></span>
                                                    <span
                                                        [ngClass]="getFieldStrikethroughClass('linked_cm_capital', versionType)">{{getFieldValueForDisplay('linked_cm_capital',
                                                        data?.linked_cm_capital,
                                                        versionType)
                                                        ? 'Sim' :
                                                        'Não'}}</span>
                                                </div>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>

                    <ng-container
                        *ngTemplateOutlet="versionTemplateComparing; context: { data: getDataForView('comparing'), versionType: 'comparing' }"></ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>